<script>
	export let products;
	import Product from '../components/Product.svelte';
	let carousel;
	let index;
	let oldWidthCarousel;
	let oldWidthProduct;
	let oldWidthDummy2;
	let oldWidthDummy;
	import debounce from 'just-debounce-it';
	export let imgs;
	export let feel;
</script>

<style>
	.carousel {
		width: 100%;
		overflow-x: auto;
		display: flex;
		scroll-snap-type: x mandatory;
		touch-action: pan-x;
		padding-top: 1em;
		padding-bottom: 1em;
		flex: 1 0;
	}
	.dummy {
		flex: 1 0 20vw;
	}
	.dummy2 {
		flex: 1 0 5vw;
	}
	.carousel > :nth-last-child(2) {
		display: none;
	}
</style>

<svelte:window
	on:resize={debounce(() => {
		oldWidthCarousel = carousel.clientWidth;
		oldWidthProduct = carousel.querySelector('.card').getBoundingClientRect().width;
		oldWidthDummy2 = carousel.querySelector('.dummy2').getBoundingClientRect().width;
		oldWidthDummy = carousel.querySelector('.dummy').getBoundingClientRect().width;
		carousel.scrollLeft = index * (oldWidthProduct + oldWidthDummy2) + oldWidthDummy;
	}, 100, true)}
/>
<div
	class="carousel"
	bind:this={carousel}
	on:scroll={debounce(e => {
		if(carousel.clientWidth === oldWidthCarousel) {
			index = Math.round((carousel.scrollLeft + oldWidthCarousel / 2 - oldWidthProduct / 2 - oldWidthDummy) / (oldWidthProduct + oldWidthDummy2));
			//                  center of page which is center of card       beginning of card     20vw offset to center the first( and last) card
			//                                                                                                      true length of card is (60 + 5)vw
		}
	}, 200)}
	on:introstart={() => {
		carousel.scrollLeft = 1;
		oldWidthCarousel = carousel.clientWidth;
		oldWidthProduct = carousel.querySelector('.card').getBoundingClientRect().width;
		oldWidthDummy2 = carousel.querySelector('.dummy2').getBoundingClientRect().width;
		oldWidthDummy = carousel.querySelector('.dummy').getBoundingClientRect().width;
	}}
>
	<div class="dummy"></div>
	{#each products as product (product.id)}
		<Product {feel} bind:imgs style="flex: 0 0 60vw" bind:product={product} />
		<div class="dummy2"></div>
	{/each}
	<div class="dummy"></div>
</div>